"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveQrAsPdf = exports.saveQrAsPng = exports.getImageAsBase64 = exports.saveActivationQrAsPng = exports.saveTicketAsPNG = exports.saveActivationQrAsPdf = exports.saveTicketAsPDF = void 0;
//@ts-ignore
const html2pdf_min_js_1 = __importDefault(require("html2pdf.js/dist/html2pdf.min.js"));
const qrcode_helper_1 = require("./../qrcode_helper");
const png_helper_1 = require("../png_helper");
const ticket_helper_1 = require("../ticket_helper");
const activation_qr_helper_1 = require("../activation_qr_helper");
const getDefaultName = (ticketId, type) => {
    return `${ticketId}_ticket.${type}`;
};
const savePdf = (html, fileName, quality) => __awaiter(void 0, void 0, void 0, function* () {
    const pdfOptions = {
        html2canvas: {
            scale: quality !== null && quality !== void 0 ? quality : 5,
            useCORS: true
        },
        filename: fileName,
        margin: [3, 3, 0, 0]
    };
    return yield (0, html2pdf_min_js_1.default)().set(pdfOptions).from(html).save();
});
const getPngBase64 = (html, quality) => __awaiter(void 0, void 0, void 0, function* () {
    const imgOptions = {
        html2canvas: {
            width: 344,
            scale: quality !== null && quality !== void 0 ? quality : 5,
            useCORS: true
        }
    };
    const img = yield (0, html2pdf_min_js_1.default)().set(imgOptions).from(html).toImg().outputImg();
    return img.src;
});
const saveTicketAsPDF = (ticket, lang, fileName, quality, demo) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const default_file_name = getDefaultName(ticket.ticketId, 'pdf');
    const html = (0, ticket_helper_1.generateTicketHTML)(ticket, lang, undefined, demo);
    return yield savePdf(html, (_a = `${fileName}.pdf`) !== null && _a !== void 0 ? _a : default_file_name, quality);
});
exports.saveTicketAsPDF = saveTicketAsPDF;
const saveActivationQrAsPdf = (data, lang, fileName, quality, demo) => __awaiter(void 0, void 0, void 0, function* () {
    var _b;
    const default_file_name = getDefaultName(data.gateName, 'pdf');
    const html = (0, activation_qr_helper_1.generateActivationHTML)(data, lang, undefined, demo);
    return yield savePdf(html, (_b = `${fileName}.pdf`) !== null && _b !== void 0 ? _b : default_file_name, quality);
});
exports.saveActivationQrAsPdf = saveActivationQrAsPdf;
const saveTicketAsPNG = (ticket, lang, fileName, quality, demo) => __awaiter(void 0, void 0, void 0, function* () {
    var _c;
    const default_file_name = getDefaultName(ticket.ticketId, 'png');
    const html = (0, ticket_helper_1.generateTicketHTML)(ticket, lang, true, demo);
    const imageBase64 = yield getPngBase64(html, quality);
    return (0, png_helper_1.saveFileAsPng)(imageBase64, (_c = `${fileName}.png`) !== null && _c !== void 0 ? _c : default_file_name);
});
exports.saveTicketAsPNG = saveTicketAsPNG;
const saveActivationQrAsPng = (data, lang, fileName, quality, demo) => __awaiter(void 0, void 0, void 0, function* () {
    var _d;
    const default_file_name = getDefaultName(data.gateName, 'png');
    const html = (0, activation_qr_helper_1.generateActivationHTML)(data, lang, true, demo);
    const imageBase64 = yield getPngBase64(html, quality);
    return (0, png_helper_1.saveFileAsPng)(imageBase64, (_d = `${fileName}.png`) !== null && _d !== void 0 ? _d : default_file_name);
});
exports.saveActivationQrAsPng = saveActivationQrAsPng;
const getImageAsBase64 = ({ ticket, qrData, quality, lang, demo }) => __awaiter(void 0, void 0, void 0, function* () {
    let html = ``;
    if (ticket)
        html = (0, ticket_helper_1.generateTicketHTML)(ticket, lang, true, demo);
    if (qrData)
        html = (0, activation_qr_helper_1.generateActivationHTML)(qrData, lang, true, demo);
    return yield getPngBase64(html, quality);
});
exports.getImageAsBase64 = getImageAsBase64;
const saveQrAsPng = (qrCode, fileName, quality) => __awaiter(void 0, void 0, void 0, function* () {
    const html = (0, qrcode_helper_1.generateQRCodeHTML)(qrCode);
    const imgOptions = {
        html2canvas: {
            width: 201,
            scale: quality !== null && quality !== void 0 ? quality : 5
        }
    };
    const img = yield (0, html2pdf_min_js_1.default)().set(imgOptions).from(html).toImg().outputImg();
    const imageBase64 = img.src;
    return (0, png_helper_1.saveFileAsPng)(imageBase64, `${fileName}.png`);
});
exports.saveQrAsPng = saveQrAsPng;
const saveQrAsPdf = (qrCode, fileName, quality) => __awaiter(void 0, void 0, void 0, function* () {
    const html = (0, qrcode_helper_1.generateQRCodeHTML)(qrCode);
    return yield savePdf(html, `${fileName}.pdf`, quality);
});
exports.saveQrAsPdf = saveQrAsPdf;
